<template>
  <transition name="confirm-fade">
    <div class="confirm" v-show="showFlag" @click.stop>
      <div class="confirm-wrapper">
        <div class="confirm-content">
          <div class="header-text">
            <p class="text">{{text}}</p>
            <i v-if="cancelA" class="iconfont icon-clear close"  @click.stop="cancelA"></i>
            <i v-else class="iconfont icon-clear close"  @click="closeHide"></i>
          </div>
          <div v-if="isShows" class="content item-break-all-word" style="font-weight: 700;">
            {{ conDescOne }}
          </div>
          <div v-if="btnCan == null" class="content item-break-all-word">
            <div>该岗位有未生成周考核</div>
            <div>无法删除岗位</div>
          </div>
          <div v-else-if="cancelA" v-html="conDesc" class="content item-break-all-word">
          </div>
          <div v-else class="content item-break-all-word">
            <slot>{{conDesc}}</slot>
          </div>
          <div v-if="cancelA" class="operate">
            <span @click.stop="cancelA" v-if="btnCan != null" class="left">{{btnCan}}</span>
            <span @click.stop="confirmA" class="right">{{btnOk}}</span>
          </div>
          <div v-else class="operate">
            <span v-if="btnCan" @click="cancel" class="left">{{btnCan}}</span>
            <span @click="confirm" class="right">{{btnOk}}</span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '小西提醒'
    },
    desc: {
      type: String,
      default: '是否退出当前账号'
    },
    confirmBtnText: {
      type: String,
      default: '是'
    },
    cancelBtnText: {
      type: String,
      default: '否'
    },
    conDescOne: {
      type: String,
      default: '确认忘记密码？'
    },
    isShow: {
      type: Boolean,
      default: false
    },
    showOne: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showFlag: false,
      btnCan: this.cancelBtnText,
      btnOk: this.confirmBtnText,
      conDesc: this.desc,
      cancelA: null,
      confirmA: null,
      isShows: this.isShow,
      showOneS: this.showOne
    }
  },
  methods: {
    show () {
      this.showFlag = true
    },
    hide () {
      this.showFlag = false
    },
    cancel () {
      this.hide()
      this.$emit('cancel')
    },
    closeHide () {
      this.hide()
      this.$emit('close')
    },
    confirm () {
      this.hide()
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable'
.confirm
  position: fixed
  left: 0
  right: 0
  top: 0
  bottom: 0
  z-index: 998
  background-color: $color-background-d
  &.confirm-fade-enter-active
    animation: popup-fadein 0.3s
    transform-origin: center
    .confirm-content
      animation: confirm-zoom 0.3s
  .confirm-wrapper
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    z-index: 999
    .confirm-content
      width: 300px
      .text
        padding: 30px 15px 10px
        line-height: 22px
        text-align: center
        font-size: $font-size-large-m
        color: $color-text
        background: #fff
        border-top-right-radius: 3px
        border-top-left-radius: 3px
      .content
        background-color: $color-white
        color: #4f4f4f
        padding: 10px 20px 15px
        text-align: center
        line-height: 20px
        font-size: $font-size-medium-x
        margin-top: -1px
      .operate
        background-color: $color-white
        font-size: $font-size-medium-x
        line-height: 22px
        padding: 10px 20px 35px
        color: $color-red
        text-align: right
        margin-top: -1px
        border-bottom-right-radius: 3px
        border-bottom-left-radius: 3px
        span
          cursor: pointer
          display: block
          text-align: center
          padding: 6px 0
          border-radius: 3px
        .left
          color: #e43d39
          background-color: #fad8d7
          margin-bottom: 15px
        .right
          color: #fff
          background-color: #e43d39
.header-text
  position: relative
  .close
    position: absolute
    right: 25px
    top: 28px
    cursor: pointer
</style>



// WEBPACK FOOTER //
// src/base/confirm/confirm.vue